<template>
  <div class="pane">
    <Title :title="title"></Title>
    <div class="wrap">
      <slot></slot>
    </div>                                
  </div>
</template>

<script>
import Title from '@/components/Title/title.vue'


export default {
  name: 'pane',
  props:{
    title:{type:String,default:''},
    imgsrc:{type:String,default:''}
  },
  components:{Title},
  mounted(){
    // console.log(this.imgsrc)
  }
}
</script>

<style scoped>
.pane{
  overflow:hidden;
  background-color: #ccc;
  background: url(../../../assets/index/pane-bg01.png) no-repeat 0 0;
  background-size: contain;
}
.pane .title-box{margin:5.02765vw 0 3.47368vw 6.23428859vw }
.pane .wrap{margin:0 auto; width:69.473684vw; background:#fff;}


@media (min-width: 992px){}
@media (max-width: 991px){
.pane{background-size: 100% 28vw;}
.pane .title-box{margin:8.02765vw 0 3.47368vw 6.23428859vw }
.pane .wrap{margin:0 auto; width:95%; background:#fff;}

}
</style>